import React, { useState, useEffect, useRef } from 'react';
import { NavLink, Link, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { useAuth } from './context/AuthContext';
import { useAppTranslation } from "./components/TranslationContext";

export const Navigation = () => {
    const { user, logout, isAuthenticated, language, setLanguage } = useAuth();
    const [menuOpen, setMenuOpen] = useState(false);
    const [avatarUrl, setAvatarUrl] = useState("/images/user.png");
    const navigate = useNavigate();
    const menuRef = useRef();
    const location = useLocation();
    const isHome = location.pathname === "/" || location.pathname === "/about";

    const { i18n } = useTranslation();
    const { t, setLang, lang } = useAppTranslation();

    // При монтировании — применить язык
    useEffect(() => {
        if (language) {
            i18n.changeLanguage(language);
            setLang(language);
        }
    }, [language, i18n, setLang]);

    const changeLanguage = (newLang) => {
        i18n.changeLanguage(newLang);
        setLanguage(newLang);
        setLang(newLang);
        localStorage.setItem('language', newLang);
    };

    // Загрузка фото пользователя
    useEffect(() => {
        const fetchAvatar = async () => {
            if (user?.id) {
                try {
                    const res = await fetch(`https://api.rasulova-academy.uz/api/custom-users/?user=${user.id}`);
                    const data = await res.json();
                    if (data.length > 0 && data[0].img) {
                        setAvatarUrl(data[0].img);
                    }
                } catch (err) {
                    console.error("Ошибка загрузки аватара:", err);
                }
            }
        };
        fetchAvatar();
    }, [user]);

    // Закрытие меню при клике вне
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setMenuOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleLogout = () => {
        logout();
        setMenuOpen(false);
        navigate('/');
    };

    return (
        <nav className={`nav ${isHome ? "nav--home" : "navBGwhite"}`}>
            <div className="nav__left">
                <img className='logo__img' src="/images/logo.png" alt="logotip" />
                <Link className="logo" to="/">
                    <span>{t('logoTitle')}</span>
                    <p>{t('logoSub')}</p>
                </Link>
            </div>

            <div className="links">
                <NavLink to="/courses" className={({ isActive }) => `link ${isActive ? 'active' : ''}`}>
                    {t('menuCourses')}
                </NavLink>
                <NavLink to="/about" className={({ isActive }) => `link ${isActive ? 'active' : ''}`}>
                    {t('menuAbout')}
                </NavLink>
            </div>

            <div className="nav__info">
                <div className="login lang">
                    <button
                        className={`link navLink__lang ${lang === 'ru' ? 'active-lang' : ''}`}
                        onClick={() => changeLanguage('ru')}
                    >Ru</button>
                    <button
                        className={`link navLink__lang ${lang === 'en' ? 'active-lang' : ''}`}
                        onClick={() => changeLanguage('en')}
                    >En</button>
                    <button
                        className={`link navLink__lang ${lang === 'uz' ? 'active-lang' : ''}`}
                        onClick={() => changeLanguage('uz')}
                    >Uz</button>
                </div>

                <div className="login">
                    {isAuthenticated ? (
                        <div className='avatarWrapper' style={styles.avatarWrapper}>
                            <img
                                src={avatarUrl}
                                alt="User"
                                className="profile__avatar"
                                onClick={() => setMenuOpen(!menuOpen)}
                            />
                            {menuOpen && (
                                <div className="profile__menu" ref={menuRef}>
                                    {user && (
                                        <div className="profile__info">
                                            <p style={{ fontWeight: 'bold', marginBottom: '5px' }}>{user.username}</p>
                                            <p style={{ fontSize: '12px', color: '#777' }}>{user.email}</p>
                                        </div>
                                    )}
                                    <NavLink to="/profile" className="link" onClick={() => setMenuOpen(false)}>
                                        <img src="https://cdn-icons-png.flaticon.com/128/9308/9308015.png" alt="Профиль" />
                                        <p>{t('profile')}</p>
                                    </NavLink>
                                    <Link to="/" className="link" onClick={handleLogout}>
                                        <img src="https://cdn-icons-png.flaticon.com/128/1286/1286853.png" alt="Выйти" />
                                        <p>{t('logout')}</p>
                                    </Link>
                                </div>
                            )}
                        </div>
                    ) : (
                        <Link to="/login" className="link">{t('login')}</Link>
                    )}
                </div>
            </div>
        </nav>
    );
};

const styles = {
    avatarWrapper: { position: 'relative' },
};
